export const regulations = {
  EXTENDED_AT: 'ÖNORM EN 1991-1-4',
  DEFAULT_AT: 'ÖNORM B 3419',
  DEFAULT_DE: 'DE',
}
